import { memo } from 'react';

import { Button } from '@shared/ui/Button';

import { useCdekWidget } from '../../CdekWidget';
import cls from './PointsContent.module.scss';

export const PointsContent = memo(() => {
  const { points, selectPoint, showPointInfo } = useCdekWidget() || {};

  return (
    <div className={cls.wrapper}>
      {points?.map((point) => {
        const {
          code,
          location: { city, address }
        } = point;

        return (
          <div
            key={code}
            className={cls.deliveryPoint}
          >
            <div className={cls.locationName}>{`${city}, ${address}`}</div>
            <div className={cls.buttonsWrapper}>
              <Button
                size="s"
                onClick={selectPoint?.(point)}
              >
                Заберу отсюда
              </Button>
              <Button
                size="s"
                variant={'secondary'}
                onClick={showPointInfo?.(point)}
              >
                О пункте
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
});
